import { GetAllMovedGoodsId } from "./api";
// import taoteHandler from './platform/taote/handler'
import aliHandler from "./platform/1688/handler";
import indexHandler from "../../handler";
import aliUtil from "@/utils/check_ali_auth";

// 获取对应平台的handler
function GetCurrentPlatformHandler() {
  // let handler = taoteHandler
  // if (type?.includes('ali')) handler = aliHandler
  return aliHandler;
}

// 淘特和1688选品专属的，获取商品池选项列表
async function getPoolList(This) {
  const item = This.currentItem;
  const handler = GetCurrentPlatformHandler(item.type);
  let { pools } = await handler.GetPoolList();
  pools.unshift({ label: "全部", value: "" });
  clearPools(pools);
  item.typeOptions = pools;
}

function clearPools(pools) {
  //清洗货盘标签
  const chunjie = pools.filter((res) => {
    return res.label.indexOf("春节不打烊") > -1;
  });
  if (chunjie.length > 0) {
    chunjie[0].label = chunjie[0].label.replace("抖音", "");
    chunjie[0].tip = "";
  }
}
let taoteCategoryList = [];

// 淘特和1688选品专属的，获取第一级分类列表
async function getFirstCategory(This) {
  const item = This.currentItem;
  const handler = GetCurrentPlatformHandler(item.type);
  const { list } = await handler.GetCategoryList({});
  list.sort((a, b) => a.label.length - b.label.length); // 按类目名称的长度升序
  item.categoryList = list;
  taoteCategoryList = JSON.parse(JSON.stringify(list));
  for (let c of [...This.activekeyList]) {
    let cateList = list,
      h = handler;
    if (c.type === "taote") {
      cateList = taoteCategoryList;
      h = GetCurrentPlatformHandler("taote");
    }
    c.categoryList = c.isOnlyFirstCategory
      ? cateList.filter((ca) => h?.CategoryIds?.includes(ca.value) || h.categoryIdMap?.[c.apiTag]?.includes(ca.value))
      : JSON.parse(JSON.stringify(list));
  }
}

// 初始化, 获取对应数据
async function InitData(This) {
  aliUtil.SyncCategory();
  await aliUtil.SetLocalData("hide-msg");
  await getPoolList(This);
  await getFirstCategory(This);
  GetData(This);
}

// 格式化搜词接口返回的数据
async function formatGoodsList(list, { type, value }) {
  const arr = [];
  for (let item of list) {
    let link = `https://market.m.taobao.com/app/ltao-fe/ltao-lite/productdetail.html?id=${item.goodsId}`;
    if (type.includes("ali")) link = `https://detail.1688.com/offer/${item.goodsId}.html`;
    const img = type.includes("taote")
      ? "https://img.alicdn.com/imgextra/" + item.imageUrl
      : item.imageUrl.replace(/^(.*uploaded)/, "https://img.alicdn.com/imgextra/i");
    const obj = {
      id: item.goodsId,
      name: item.goodsName,
      img,
      link,
      price: item.price ? +item.price : 0,
      sold: item.sold,
      serviceList: item.serviceList,
      tradeName: item.tradeName,
      category: item.category,
    };
    // 淘特选品或者淘特精选货盘
    if (type?.includes("taote"))
      GetCurrentPlatformHandler(type).SetParams?.({ item, obj, type: value, categoryList: taoteCategoryList });
    arr.push(obj);
  }
  return arr.filter((obj) => !obj.name.includes("情趣内衣"));
}

// 根据接口返回的已铺货的商品id集合给商品加一个标记
async function setIsMoved(list, obj) {
  let isMovedIdMap = sessionStorage.getItem("pdd_xiaofeng_shanghuo_is_moved_success_ids");
  isMovedIdMap = isMovedIdMap ? JSON.parse(isMovedIdMap) : await GetAllMovedGoodsId();
  if (isMovedIdMap && Object.keys(isMovedIdMap).length) {
    list.map((item) => {
      item.isMoved = isMovedIdMap[item.id] && !obj?.canCommitRepeat ? true : false;
    });
  }
}

// 获取搜词数据
async function getGoodsList(This) {
  const currentItem = This.currentItem;
  let obj = { ...currentItem.params };
  This.loading = true;
  if (currentItem.lowPriceFlow) obj.poolId = currentItem.lowPriceFlow;
  if (currentItem.value === "taoteKeyword") {
    // 价格区间
    if (obj.minPrice && !obj.maxPrice) obj.price = obj.minPrice + "~";
    else if (!obj.minPrice && obj.maxPrice) obj.price = "~" + obj.maxPrice;
    else if (obj.minPrice && obj.maxPrice) obj.price = obj.minPrice + "~" + obj.maxPrice;
  }
  const fn = currentItem.api;
  const { list, msg, success, info, total } = await fn(obj);
  This.selectedRows = [];
  This.loading = false;
  if (!success) {
    !info && This.$message.warning(msg);
    // 淘特
    if (typeof info === "object") indexHandler.ShowTaoteAuthModal(This, info);
    // 1688
    else if (info) {
      await indexHandler.ShowAliAuthModal(info);
      return getGoodsList(This);
    }
    currentItem.list = [];
    return (currentItem.params.total = 0);
  }
  if (!list.length) {
    currentItem.list = [];
    currentItem.params.total = 0;
    return This.$message.warning("没有搜索到商品数据，请重试");
  }
  currentItem.list = await formatGoodsList(list, currentItem);
  currentItem.params.total = total;
  This.$message.success("加载成功");
  setIsMoved(currentItem.list, { canCommitRepeat: This.$refs.currentGoodsTemplate?.is_repeat });
}

// 获取商品数据
async function GetData(This) {
  getGoodsList(This);
  if (document.querySelector(".moving-select-goods")) document.querySelector(".moving-select-goods").scrollTop = 0;
}

// 判断是否可以进行商品预览（必须选择1个商品模板才可以）
function isPassPreviewValidate(This, list) {
  const goodsTemplateId = This.$refs.createGoodsTemplateModal?.goodsTemplateId;
  if (!goodsTemplateId) {
    This.$message.warning("请先选择 1 个商品模板");
    return false;
  }
  This.$emit("move-preview", { list, goodsTemplateId });
  return true;
}

// 单个商品铺货预览
function SingleAddPreview(This, arr) {
  isPassPreviewValidate(This, arr);
}

// 批量商品铺货预览
function BatchAddPreview(This) {
  if (!This.getSelectedRows.length) return This.$message.warning("请至少选择 1 个商品");
  isPassPreviewValidate(This, This.getSelectedRows) && This.clearSelectedGoods();
}

// 点击商品item时
function ClickItem(list, item) {
  // 如果是选中某个则push到数组里, 否则删除数组里已选的
  item.selected
    ? list.push(item)
    : list.splice(
        list.findIndex((i) => i.id === item.id),
        1
      );
}

// 清空已选择的商品集合
function ClearSelectedGoods(item) {
  item.selectedList = [];
  item.list.map((item) => {
    item.selected = false;
  });
}

// 全选/反选
function ChangeCheckAll(bool, currentItem, goodsTemplateModal) {
  // 如果是全选
  if (bool) {
    for (let item of currentItem.list) {
      const current = currentItem.selectedList.find((i) => i.id === item.id),
        noIsMovedOrCanRepeatMove = !item.isMoved || goodsTemplateModal?.currentGoodsTemplate?.is_repeat;
      // 如果是已经选择的,并且没有铺货过或者是允许铺重复的,那就选中,否则不变
      if (current) current.selected = noIsMovedOrCanRepeatMove ? bool : item.selected;
      // 如果还没选中,那就选中
      else if (noIsMovedOrCanRepeatMove) currentItem.selectedList.push(item);
    }
  }
  // 取消全选就清空已选择的
  else currentItem.selectedList = [];
}

// 根据路由获取指定平台列表
function GetRouterByPlatform() {
  return [{ label: "1688", value: "ali" }];
}

export default {
  InitData,
  GetCurrentPlatformHandler,
  SingleAddPreview,
  BatchAddPreview,
  GetData,
  GetRouterByPlatform,
  ClickItem,
  ClearSelectedGoods,
  ChangeCheckAll,
};
